window.dataLayer.push({ ecommerce: null });
var checkoutixIn = {};
var customerixIn = {};
function ixUserData(customerix) {
  var customer = {
      event: 'user_data',
      user_id: customerix.user_id,
      user_first_name: customerix.user_first_name,
      user_last_name: customerix.user_last_name,
      user_email: customerix.user_email,
      user_email_hash: customerix.user_email_hash,
      user_phone: customerix.user_phone,
      user_address: customerix.user_address,
      user_postcode: customerix.user_postcode,
      user_country: customerix.user_country,
      user_city: customerix.user_city,  
    };
  console.log("TRACKING_ix:: USER_DATA ");
  window.dataLayer.push(customer);
  console.log(customer);
  saveCustomerDataIx(customer);
  console.log("TRACKING_ix:: SAVE_USER_DATA ");
}
function ixProductData(productix,customerix) {
  var infomation = {
    currency: productix.currency,
    value: productix.value,
    items: [
    {
      item_id: productix.item_id,
      item_name: productix.item_name,
      affiliation: productix.affiliation,
      discount: productix.discount,
      index: 0,
      item_brand: productix.item_brand,
      item_category: productix.item_category,
      item_category2: productix.item_category2,
      item_category3: productix.item_category3,
      item_category4: productix.item_category4,
      item_category5: productix.item_category5,
      item_list_id: productix.item_list_id,
      item_list_name: productix.item_list_name,
      item_variant: productix.item_variant,
      location_id: productix.location_id,
      price: productix.price,
      quantity: 1
    }
    ]
  };
  console.log("TRACKING_ix:: VIEW_ITEM ");
  var event = {event: "view_item_ix",ecommerce: infomation, user_data: customerix};
  console.log(event);
  window.dataLayer.push(event);

}
function ixCollectionData(collectionix,customerix) {
  console.log("TRACKING_ix:: VIEW_LIST_ITEM ");
  var event = {event: "view_item_list_ix",ecommerce: collectionix, user_data: customerix};
  console.log(event);
  window.dataLayer.push(event);
}

function ixCartData(cartix,customerix) {
  console.log("TRACKING_ix:: VIEW_CART ");
  var event = {event: "view_cart_ix",ecommerce: cartix, user_data: customerix};
  console.log(event);
  window.dataLayer.push(event);
}

function ixSignUpLogin(globalEvent,method,shop) {
  window.dataLayer.push({ ecommerce: null });
  console.log("TRACKING_ix:: SIGN_UP/LOGIN");
  var event = {event: globalEvent,ecommerce: {method:method}};
  window.dataLayer.push(event);
  console.log(event);
  return true;
}

function ixBeginCheckoutData(globalEvent,cartix) {
  window.dataLayer.push({ ecommerce: null });
  console.log("TRACKING_ix:: BEGIN_CHECKOUT");
  var event = {event: globalEvent,ecommerce: cartix, user_data: customerixIn};
  window.dataLayer.push(event);
  console.log(event);
  return true;
}

async function getProductByHandle(handle) {
  const response = await fetch(`/products/${handle}.js`);
  const product = await response.json();
  return product;
}

function ixTrackData(event,handle,variant,currency,shop) {
  var globalEvent = event;
  var globalCurrency = currency;
  var globalShop = shop;
  getProductByHandle(handle).then(product => {
    window.dataLayer.push({ ecommerce: null });
    var discount = 0;
    if (product.compare_at_price!=undefined && product.compare_at_price!=null && product.compare_at_price > product.price) {
      discount = product.compare_at_price -product.price;
    } 
    var price = 0;
    if (product.compare_at_price!=undefined && product.compare_at_price!=null && product.compare_at_price > product.price) {
      price = product.compare_at_price;
    } else {
      price = product.price;
    }
    if(price!=0) {
      price = price+"";
      var len = price.length;
      price = price.substring(0, len-2) + "." + price.substring(len-2);
      price = parseFloat(price).toFixed(2);;
    }
    if(discount!=0) {
      discount = discount+"";
      len = discount.length;
      discount = discount.substring(0, len-2) + "." + discount.substring(len-2);
      discount = parseFloat(discount).toFixed(2);;
    }
    pricediscount = (price-discount);
    pricediscount.toFixed(2);
    var quantity = 1;
    var price = price;
    if(globalEvent=="add_to_cart_ix") {
      var qntField = document.querySelector("input[name='quantity']"); 
      if(qntField && qntField.type=="number") {
        quantity = qntField.value;
        //price = price*qntField.value;
        pricediscount = pricediscount*qntField.value;
      }
    }
    var infomation = {
      currency: globalCurrency,
      value: pricediscount,
      items: [
      {
        item_id: product.id,
        item_name: product.title,
        affiliation: globalShop,
        discount: discount,
        index: 0,
        item_brand: product.vendor,
        item_category: "",
        item_category2: "",
        item_category3: "",
        item_category4: "",
        item_category5: "",
        item_list_id: "",
        item_list_name: "",
        item_variant: "",
        location_id: "",
        price: price,
        quantity: quantity
      }
      ]
    };
    console.log("TRACKING_ix:: "+globalEvent);
    var event = {event: globalEvent,ecommerce: infomation, user_data: customerixIn};
    window.dataLayer.push(event);
    console.log(event);
    return true;
  });
}

function ixEvents(item, index, arr) {
  item.addEventListener('click', function(e) {
    var event = this.dataset.event;
    var product = this.dataset.product;
    var shop = this.dataset.shop;
    var currency = this.dataset.currency;
    var variant = this.dataset.variant!=undefined ? this.dataset.variant : "";
    if(event=="signup_ix" || event=="login_ix") {
      var method = this.dataset.method!=undefined ? this.dataset.method : "standard";
      ixSignUpLogin(event,method,shop);
    } else if(event=="begin_checkout_ix") {
      ixBeginCheckoutData(event,checkoutixIn);
    } else if(product!=""){
      ixTrackData(event,product,variant,currency,shop);
    } else {
      console.log("TRACKING_ix:: event not present or without product handle");
    }
  });
}

function ixSelectItem(handle,collectionix,currencyix,shopix,customerix) {
  var collectionName = (collectionix!=undefined && collectionix.item_list_id) ? collectionix.item_list_id : "";
  var collectionId = (collectionix!=undefined && collectionix.item_list_name) ? collectionix.item_list_name : "";
  if(handle!=undefined) {
    getProductByHandle(handle).then(product => {
      console.log(product);
      window.dataLayer.push({ ecommerce: null });
      var discount = 0;
      if (product.compare_at_price!=undefined && product.compare_at_price!=null && product.compare_at_price > product.price) {
        discount = product.compare_at_price -product.price;
      } 
      var price = 0;
      if (product.compare_at_price!=undefined && product.compare_at_price!=null && product.compare_at_price > product.price) {
        price = product.compare_at_price;
      } else {
        price = product.price;
      }

      if(price!=0) {
        price = price+"";
        var len = price.length;
        price = price.substring(0, len-2) + "." + price.substring(len-2);
        price = parseFloat(price).toFixed(2);;
      }
      if(discount!=0) {
        discount = discount+"";
        len = discount.length;
        discount = discount.substring(0, len-2) + "." + discount.substring(len-2);
        discount = parseFloat(discount).toFixed(2);;
      }
      var infomation = {
        item_list_id: collectionId,
        item_list_name: collectionName,
        items: [
          {
            item_id: product.id,
            item_name: product.title,
            affiliation: shopix,
            discount: discount,
            index: 0,
            item_brand: product.vendor,
            item_category: collectionName,
            item_category2: "",
            item_category3: "",
            item_category4: "",
            item_category5: "",
            item_list_id: collectionId,
              item_list_name: collectionName,
            item_variant: "",
            location_id: "",
            price: price,
            quantity: 1
          }
        ]
      };
      console.log("TRACKING_ix:: SELECT_ITEM ");
      //{% if customer %}user_id: '{{ customer.id }}',user_first_name: '{{ customer.first_name | remove: "'" | remove: '"' }}',user_last_name: '{{ customer.last_name | remove: "'" | remove: '"' }}',user_email: '{{ customer.email | remove: "'" | remove: '"' }}',user_email_hash: '{{ customer.email | remove: "'" | remove: '"' | sha256 }}',user_phone: '{{ customer.phone | remove: "'" | remove: '"' | sha256 }}',user_address: '{{ customer.default_address.address1 | remove: "'" | remove: '"' }}',user_postcode: '{{ customer.default_address.zip | remove: "'" | remove: '"' }}',user_country: '{{ customer.default_address.country_code | remove: "'" | remove: '"' }}',user_city: '{{ customer.default_address.city | remove: "'" | remove: '"' }}',{% endif %}
      var event = {event: "select_item_ix",ecommerce: infomation, user_data: customerix};
      window.dataLayer.push(event);
      console.log(event);
      return true;
    });
  }
}

function saveCustomerDataIx(customer) {
  const jsonString = JSON.stringify(customer);
  const encodedData = btoa(jsonString);
  localStorage.setItem('data_ix', encodedData);
}


function loadAsynchTrack(collectionix,currencyix,shopix,customerix,checkoutix) {
  checkoutixIn = checkoutix;
  customerixIn = customerix;
  const elements = document.querySelectorAll('[data-tracking="ix"]');
  elements.forEach(ixEvents);

  const griditem = document.querySelectorAll('.card-wrapper a');
  for (let i = 0; i < griditem.length; i++) {  
    griditem[i].addEventListener('click', function(event) {
      const parentWithClass = griditem[i].closest('.card-wrapper');
      ixSelectItem(parentWithClass.dataset.handle,collectionix,currencyix,shopix,customerixIn);
    });
  }
}
